import "../CSS/mesureSettings.css";
import React, { useState, useEffect } from "react";
import { ref, onValue } from "firebase/database";
import db from "../FireBase/firebase";
import MesureSettings from "./MesureSettings";

function MesuresSettingsV2({ onChange }) {
  const [paramGraph, setParamGraph] = useState([]);
  const [selectedMesure, setSelectedMesure] = useState(null);

  useEffect(() => {
    fetchMesures();
  }, []);

  function fetchMesures() {
    const paramRef = ref(db, "parametres/mesures");
    const unsubscribe = onValue(
      paramRef,
      (snapshot) => {
        const fetchedMesures = [];
        snapshot.forEach((childSnapshot) => {
          const key = childSnapshot.key;
          const visible = childSnapshot.val().visible;
          fetchedMesures.push({ id: key, visible: visible });
        });
        setParamGraph(fetchedMesures);
        console.log(fetchedMesures);
      },
      (error) => {
        console.error("Erreur lors du chargement des paramètres de mesure :", error);
      }
    );

    return () => unsubscribe();
  }

  return (
    <div id="paramsMesures">
      {selectedMesure ? (
        <div id="modifMesure">
          <MesureSettings
            name={selectedMesure}
            isChecked={paramGraph.find((mesure) => mesure.id === selectedMesure)?.visible}
            onChange={onChange}
          />
          <button id="retourButton" onClick={() => setSelectedMesure(null)}>Retour</button>
        </div>
      ) : (
        <>
          <div id="selectMesure">
            {paramGraph.map((mesure) => (
              <div key={mesure.id}>
                <button
                  id="buttonParamMesure"
                  className={mesure.visible ? "visible" : ""}
                  onClick={() => setSelectedMesure(mesure.id)}
                  onContextMenu={(e) => {onChange(mesure.id); e.preventDefault();}}
                >
                  {mesure.id}
                </button>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default MesuresSettingsV2;